module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d12e146"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d12e148"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/cover",
      "id": "d12e149"
    }
  }, [_vm._v("Cover Page")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d12e150"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c3_r1#d12e59",
      "id": "d12e151"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d12e153"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c4_r1#d12e61",
      "id": "d12e154"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d12e156"
    }
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c8_r1#d12e289",
      "id": "d12e158"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d12e160"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c9_r1#d12e312",
      "id": "d12e161"
    }
  }, [_vm._v("1. The Power of Unknown Prayers")]), _c('br'), _c('i', [_vm._v("Nancy Coen")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d12e166"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c10_r1#d12e405",
      "id": "d12e167"
    }
  }, [_vm._v("2. Faith Knows No Limits")]), _c('br'), _c('i', [_vm._v("Elizabeth Swank & Ron Ballard")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d12e172"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c11_r1#d12e492",
      "id": "d12e173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. A Father’s Example")]), _c('br'), _c('i', [_vm._v("Pat Boone")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d12e178"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c12_r1#d12e584",
      "id": "d12e179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Living by Faith While Playing by the Rules")]), _c('br'), _c('i', [_vm._v("Bobby Bowden")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d12e184"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c13_r1#d12e704",
      "id": "d12e185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. All She Needed and More")]), _c('br'), _c('i', [_vm._v("Karen Kingsbury")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d12e190"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c14_r1#d12e827",
      "id": "d12e191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Happy Trails Even When Times Are Tough")]), _c('br'), _c('i', [_vm._v("Dale Evans Rogers")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d12e197"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c15_r1#d12e916",
      "id": "d12e198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. A Servant’s Heart")]), _c('br'), _c('i', [_vm._v("John Cathcart")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d12e203"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c16_r1#d12e1005",
      "id": "d12e204",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Giving Others What Mother Couldn’t Have")]), _c('br'), _c('i', [_vm._v("Truett Cathy")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d12e209"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c17_r1#d12e1074",
      "id": "d12e210",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. A Big Man’s Strong Example")]), _c('br'), _c('i', [_vm._v("Charlie Daniels")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d12e215"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c18_r1#d12e1155",
      "id": "d12e216",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. The Importance of the Word")]), _c('br'), _c('i', [_vm._v("Jerry Burden")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d12e221"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c19_r1#d12e1227",
      "id": "d12e222",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Hope Is Always Just around the Corner")]), _c('br'), _c('i', [_vm._v("James Scott Bell")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d12e227"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c20_r1#d12e1314",
      "id": "d12e228",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. A Helping Hand at the End of a Long Walk")]), _c('br'), _c('i', [_vm._v("Denise Davis ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d12e233"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c21_r1#d12e1397",
      "id": "d12e234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. The Power of a Single Prayer")]), _c('br'), _c('i', [_vm._v("Fern Nichols")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d12e239"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c22_r1#d12e1478",
      "id": "d12e240",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. You Can Go Home Again")]), _c('br'), _c('i', [_vm._v("Larry Gatlin")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d12e245"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c23_r1#d12e1573",
      "id": "d12e246",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. A Blind Date with God")]), _c('br'), _c('i', [_vm._v("Richard Stearns")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d12e251"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c24_r1#d12e1654",
      "id": "d12e252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. I Keep My Eyes on You")]), _c('br'), _c('i', [_vm._v("Cynthia Clawson")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d12e257"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c25_r1#d12e1779",
      "id": "d12e258",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Seeing Freedom behind Bars")]), _c('br'), _c('i', [_vm._v("Terri Blackstock")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d12e264"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c26_r1#d12e1868",
      "id": "d12e265",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. The Grace in a Mother’s Eyes")]), _c('br'), _c('i', [_vm._v("Don Reid")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d12e270"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c27_r1#d12e1957",
      "id": "d12e271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Off the Beaten Path")]), _c('br'), _c('i', [_vm._v("Crystal Bowman")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d12e276"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c28_r1#d12e2023",
      "id": "d12e277",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. The Wright Way")]), _c('br'), _c('i', [_vm._v("Woody Wright")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d12e282"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c32_r1#d12e2159",
      "id": "d12e283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d12e285"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Coll_ISBN0310862558_epub_c33_r1#d12e2173",
      "id": "d12e286",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Share Your Thoughts")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ddfdf72e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Coll_ISBN0310862558_epub_c7_r1.vue
// module id = 72
// module chunks = 0